// extracted by mini-css-extract-plugin
export default {"dashboard_species_select__loading":"DashboardSpeciesSelect_dashboard_species_select__loading__tMIxM"};